module.exports = __webpack_public_path__ + "static/media/bonus5.eb974ce1.jpeg";